import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "dtwin-state-aggregate"
  }, [_c('p', {
    staticClass: "card-description mt-4"
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.aggregate.description')) + "\n  ")]), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-dtwin-tree-states', {
    ref: "tree",
    attrs: {
      "tenantId": _vm.tenantId,
      "selectedStates": _vm.bindings
    },
    on: {
      "selectedState": _vm.addStateBinding,
      "deselectedState": _vm.removeStateBinding
    }
  })], 1), _vm._l(_vm.bindings, function (binding, i) {
    return _c(VRow, {
      key: i,
      staticClass: "pt-2"
    }, [_c(VCol, {
      staticClass: "py-0",
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('core-dtwin-finder', {
      attrs: {
        "readonly": true
      },
      model: {
        value: binding.dtwinId,
        callback: function ($$v) {
          _vm.$set(binding, "dtwinId", $$v);
        },
        expression: "binding.dtwinId"
      }
    })], 1), _c(VCol, {
      staticClass: "py-0",
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c(VTextField, {
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "disabled": _vm.aggregateStateLoops === false || _vm.aggregateStateLoops !== binding.id,
        "error": _vm.aggregateStateLoops !== false && _vm.aggregateStateLoops === binding.id,
        "error-messages": _vm.aggregateStateLoops !== false && _vm.aggregateStateLoops === binding.id ? _vm.$i18n_t('DigitalTwin.DigitalTwin.states.aggregate.loopError') : null,
        "value": `${binding.title} (${binding.key})`,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.dataState'),
        "readonly": ""
      },
      scopedSlots: _vm._u([{
        key: "item",
        fn: function (data) {
          return [_c(VListItemContent, [_c(VListItemTitle, {
            domProps: {
              "innerHTML": _vm._s(data.item.properties.title)
            }
          }), _c(VListItemSubtitle, [_vm._v(_vm._s(data.item.key) + " (" + _vm._s(data.item.properties.unit) + ")")])], 1)];
        }
      }, {
        key: "append-outer",
        fn: function () {
          return [_c(VBtn, {
            class: `my-0 v-btn-x v-btn--rounded bg-rounded-button-${_vm.color}`,
            attrs: {
              "color": _vm.color,
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.openDigitalTwin(binding.dtwinId, binding.id);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "color": _vm.color,
              "dark": "",
              "small": "",
              "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.showDtwinDetails'),
              "alt": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.showDtwinDetails')
            }
          }, [_vm._v("\n              fal fa-info-circle\n            ")])], 1), _c(VBtn, {
            class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "color": _vm.color,
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.removeStateBinding(binding);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-trash-alt")])], 1)];
        },
        proxy: true
      }], null, true)
    })], 1)], 1);
  }), !_vm.isNullOrEmpty(_vm.aggregateStateValue) ? _c(VRow, [_c(VCol, {
    staticClass: "mt-0 pt-0"
  }, [_c(VExpansionPanels, [_c(VExpansionPanel, {
    on: {
      "change": function ($event) {
        return _vm.refreshForm();
      }
    }
  }, [_c(VExpansionPanelHeader, [_c('div', [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.aggregate.value')) + "  \n              "), _c(VIcon, [_vm._v("fal fa-info-circle")])], 1)]), _c(VExpansionPanelContent, [_c('p', {
    staticClass: "card-description mt-0"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.aggregate.valuePreviewText1')) + "\n              "), _c('br'), _vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.aggregate.valuePreviewText2')) + "\n            ")]), _c('codemirror', {
    ref: "codemirror",
    staticClass: "elevation-3",
    attrs: {
      "value": JSON.stringify(_vm.aggregateStateValue, null, 1),
      "options": _vm.cmOptions
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };